import {Helmet} from 'react-helmet-async';
// import { Link } from 'react-router-dom';
import {useTranslation} from 'react-i18next';

const Participate = () => {
    const {t} = useTranslation();

    return (
        <>
            <Helmet>
                <title>Communitism | Participate</title>
                <meta name="description" content="Participate in the Project and our community initiatives."/>
                <meta property="og:title" content="Communitism | Participate" key="ogtitle"/>
                <meta property="og:description"
                      content="Discover more about the Communitism Project, our mission, and how to get involved."
                      key="ogdesc"/>
                <meta property="og:url" content="https://heriscope.communitism.space/about"/>
                <meta name="twitter:card" content="summary_large_image"/>
            </Helmet>

            {/* Icon Section */}
            <div className='simple-page contact-page-container'>
                <div className='row justify-content-center'>

                    <div className="content-area">
                        <h1 className="content-title">{t("Participate")}</h1>
                        <h2 className="content-sub-title">{t("Πώς μπορείς να συμμετέχεις;")}</h2>
                        <div className="content-text">
                            <ul>
                                <li>Πρόσθεσε πληροφορίες για ένα κτίριο: Αν γνωρίζεις κάποιο κτίριο πολιτιστικής κληρονομιάς
                                    σε αχρησία στο Μεταξουργείο, μπορείς να προσθέσεις πληροφορίες για την ιστορία του, την
                                    αρχιτεκτονική του, την κατάστασή του ή οτιδήποτε άλλο θεωρείς σημαντικό. Έτσι, βοηθάς
                                    στην πληρέστερη καταγραφή και ευαισθητοποίηση για την αξία του.</li>
                                <li>Είσαι ιδιοκτήτ@ κτιρίου;Αν έχεις ένα κτίριο πολιτιστικής κληρονομιάς σε αχρησία και
                                    ενδιαφέρεσαι να το διαθέσεις σε ομάδες με κοινωνικοπολιτιστικό χαρακτήρα - είτε δωρεάν
                                    είτε με χαμηλό αντίτιμο - επικοινώνησε μαζί μας! Μπορείς να συμβάλεις στη δημιουργία
                                    βιώσιμων, ζωντανών κοινόχρηστων χώρων.</li>
                                <li>Θέλεις να βοηθήσεις με άλλο τρόπο;Αν έχεις ιδέες, γνώσεις ή δεξιότητες που μπορείς να
                                    μοιραστείς, είτε σε θέματα καταγραφής, έρευνας, τεχνολογίας ή δημιουργικών παρεμβάσεων,
                                    έλα να συνδιαμορφώσουμε μαζί το φαντασιακό των κτιρίων της πόλης!</li>
                            </ul>
                            <p>Επικοινώνησε μαζί μας στο heriscope@communitism.space και γίνε μέρος της προσπάθειας!</p>
                            <p>Μαζί μπορούμε να φροντίσουμε τα κτίρια της πόλης μας 😊</p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Participate;
